import ky from 'ky'; // Not used here but import for jest
import DiTokenManager from 'auth/DiTokenManager';
import SnackbarMessageAction from 'system/SnackbarMessageAction';
import { isProductSupportMode, isReadonlyMode } from 'system/SystemUtil';
import AuthenticationUtil from 'utils/AuthenticationUtil';
import { createInstance } from './kyFactory';
import { getCSRFToken, isNewSessionEnabled } from 'auth/SessionUtil';
import { isModern } from 'utils/NavigationUtil';

const csrfToken = getCSRFToken();

let gcApi;
if (isNewSessionEnabled()) {
    gcApi = createInstance({
        prefixUrl: '/gc-api',
        hooks: {
            beforeRequest: [sessionInterceptor],
            beforeError: [responseInterceptorError]
        }
    });
} else {
    gcApi = createInstance({
        prefixUrl: '/',
        headers: {
            NK: 'NT',
            'DI-Backend': window.DI_BACKENDS && window.DI_BACKENDS.gcapi
        },
        hooks: {
            beforeRequest: [authHeaderInterceptor],
            beforeError: [responseInterceptorError]
        }
    });
}
export { gcApi };

let ghsApi;
if (isNewSessionEnabled()) {
    ghsApi = createInstance({
        prefixUrl: `https://${window.DI_BACKENDS && window.DI_BACKENDS.ghs}/`,
        credentials: 'include',
        hooks: {
            beforeRequest: [sessionInterceptor],
            beforeError: [interceptorError]
        }
    });
} else {
    ghsApi = createInstance({
        prefixUrl: `https://${window.DI_BACKENDS && window.DI_BACKENDS.ghs}/`,
        headers: { 'DI-Backend': window.DI_BACKENDS && window.DI_BACKENDS.ghs },
        // indicates whether or not cross-site Access-Control requests should be made using credentials (cookies)
        credentials: 'include',
        hooks: {
            beforeRequest: [authHeaderInterceptor],
            beforeError: [interceptorError]
        }
    });
}
export { ghsApi };

let golfApi;
if (isNewSessionEnabled()) {
    golfApi = createInstance({
        prefixUrl: '/golf-api/',
        hooks: {
            beforeRequest: [sessionInterceptor],
            beforeError: [interceptorError]
        }
    });
} else {
    golfApi = createInstance({
        prefixUrl: '/',
        headers: { 'DI-Backend': window.DI_BACKENDS && window.DI_BACKENDS.golf },
        hooks: {
            beforeRequest: [authHeaderInterceptor],
            beforeError: [interceptorError]
        }
    });
}
export { golfApi };

/**
 * ATP API
 */
let atpApi;
if (isNewSessionEnabled()) {
    atpApi = createInstance({
        prefixUrl: '/atp-api/',
        hooks: {
            beforeRequest: [sessionInterceptor],
            beforeError: [interceptorError]
        }
    });
} else {
    atpApi = createInstance({
        prefixUrl: '/',
        headers: { 'DI-Backend': window.DI_BACKENDS && window.DI_BACKENDS.atp },
        hooks: {
            beforeRequest: [authHeaderInterceptor],
            beforeError: [interceptorError]
        }
    });
}
export { atpApi };

/*
 * GCS API calls using DI OAuth
 */
let gcsApi;
if (isNewSessionEnabled()) {
    gcsApi = createInstance({
        prefixUrl: '/gcs-api/',
        hooks: {
            beforeRequest: [sessionInterceptor],
            beforeError: [interceptorError]
        }
    });
} else {
    gcsApi = createInstance({
        prefixUrl: '/',
        headers: { 'DI-Backend': window.DI_BACKENDS && window.DI_BACKENDS.gcs },
        hooks: {
            beforeRequest: [authHeaderInterceptor],
            beforeError: [interceptorError]
        }
    });
}
export { gcsApi };

/*
 *   Axios Instance for GCS calls
 */
let gcs;
if (isNewSessionEnabled()) {
    gcs = createInstance({
        prefixUrl: '/gcsalt-api/',
        hooks: {
            beforeRequest: [sessionInterceptor],
            beforeError: [interceptorError]
        }
    });
} else {
    gcs = createInstance({
        prefixUrl: '/',
        headers: { 'DI-Backend': window.DI_BACKENDS && window.DI_BACKENDS.gcsalt },
        hooks: {
            beforeRequest: [authHeaderInterceptor],
            beforeError: [interceptorError]
        }
    });
}
export { gcs };

/*
 * OMT API calls using DI OAuth
 */
let omtApi;
if (isNewSessionEnabled()) {
    omtApi = createInstance({
        prefixUrl: '/omt-api/',
        hooks: {
            beforeRequest: [sessionInterceptor],
            beforeError: [interceptorError]
        }
    });
} else {
    omtApi = createInstance({
        prefixUrl: '/',
        headers: { 'DI-Backend': window.DI_BACKENDS && window.DI_BACKENDS.omt },
        hooks: {
            beforeRequest: [authHeaderInterceptor],
            beforeError: [interceptorError]
        }
    });
}
export { omtApi };

/*
 * DI OAuth
 */
let omtCmsApiHooks = {};
if (isNewSessionEnabled()) {
    omtCmsApiHooks = {
        beforeRequest: [sessionInterceptor],
        beforeError: [interceptorError]
    };
} else {
    omtCmsApiHooks = {
        beforeRequest: [authHeaderInterceptor],
        beforeError: [interceptorError]
    };
}
const omtCmsApi = createInstance({
    prefixUrl: '/omt-cms-api',
    hooks: omtCmsApiHooks
});
export { omtCmsApi };

/*
 * Insights API calls using DI OAuth
 */
let insightsApi;
if (isNewSessionEnabled()) {
    insightsApi = createInstance({
        prefixUrl: '/insights-api/',
        hooks: {
            beforeRequest: [sessionInterceptor],
            beforeError: [interceptorError]
        }
    });
} else {
    insightsApi = createInstance({
        prefixUrl: '/',
        headers: { 'DI-Backend': window.DI_BACKENDS && window.DI_BACKENDS.insights },
        hooks: {
            beforeRequest: [authHeaderInterceptor],
            beforeError: [interceptorError]
        }
    });
}
export { insightsApi };

/*
 *   Trails API calls using DI OAuth
 */
let trailsApi;
if (isNewSessionEnabled()) {
    trailsApi = createInstance({
        prefixUrl: '/didt-api/',
        hooks: {
            beforeRequest: [sessionInterceptor],
            beforeError: [interceptorError]
        }
    });
} else {
    trailsApi = createInstance({
        prefixUrl: '/',
        headers: { 'DI-Backend': window.DI_BACKENDS && window.DI_BACKENDS.didt },
        hooks: {
            beforeRequest: [authHeaderInterceptor],
            beforeError: [interceptorError]
        }
    });
}
export { trailsApi };

/*
 *   Web API calls using DI OAuth
 */
let webApi;
if (isNewSessionEnabled()) {
    webApi = createInstance({
        prefixUrl: '/web-api/',
        hooks: {
            beforeRequest: [sessionInterceptor],
            beforeError: [interceptorError]
        }
    });
} else {
    // webApi is new.  The calls to web-data were using gcApi previously
    webApi = gcApi;
}
export { webApi };

let gcxApi;
if (isNewSessionEnabled()) {
    gcxApi = createInstance({
        prefixUrl: '/gcx-api/',
        hooks: {
            beforeRequest: [sessionInterceptor],
            beforeError: [interceptorError]
        }
    });
} else {
    gcxApi = createInstance({
        prefixUrl: '/',
        headers: { 'DI-Backend': window.DI_BACKENDS && window.DI_BACKENDS.gcx },
        hooks: {
            beforeRequest: [authHeaderInterceptor],
            beforeError: [interceptorError]
        }
    });
}
export { gcxApi };

export const itProxyApi = createInstance({
    prefixUrl: isModern() ? '/modern/it-proxy/' : '/it-proxy/',
    hooks: {
        beforeRequest: [sessionInterceptor],
        beforeError: [interceptorError]
    }
});

export const appApi = createInstance({
    prefixUrl: '/service/connect-app',
    hooks: {
        beforeRequest: [sessionInterceptor],
        beforeError: [responseInterceptorError]
    }
});

/**
 * Interceptors to handle Authoriation header for DI OAuth
 * @param {import('ky').KyRequest} request
 */
async function sessionInterceptor(request) {
    if (isNewSessionEnabled()) {
        await DiTokenManager.refreshSessionIfExpired();

        // Add the CSRF header
        if (csrfToken) {
            request.headers.set('Connect-Csrf-Token', csrfToken);
        }
    }
}

/**
 * Interceptors to handle Authoriation header for DI OAuth
 * @param {import('ky').KyRequest} request
 */
async function authHeaderInterceptor(request) {
    const token = await DiTokenManager.getToken();

    if (token) {
        request.headers.set('Authorization', `Bearer ${token}`);
    }
}

function interceptorError(error) {
    console.error('Error:', error?.message);
    return error;
}

function responseInterceptorError(error) {
    if (error.response && error.response.status === 403 && isReadonlyMode()) {
        // Ignore userpreference error
        if (!error.response.url.startsWith('/userpreference-service')) {
            SnackbarMessageAction.display({ ns: 'settings', transKey: 'read_only_mode_alert_2' });
        }
    }

    if (
        error.response &&
        error.response.status === 401 &&
        (isProductSupportMode() || isReadonlyMode()) &&
        error.response.config.url.startsWith('/modern/it-proxy')
    ) {
        // it-proxy does not have auth in account sharing modes. Ignore 401 errors.
        return;
    }

    // Do something with response error
    if (error.response && error.response.status === 401) {
        // Session is invalid, redirect to SSO sign in page to refresh session
        AuthenticationUtil.toSSOSignin();
        return;
    }

    // Invalid session
    // log user out so they can try again
    if (error?.response?.status === 403) {
        // choose userprofile-service/userprofile/userProfileBase because it is required and not called on public page
        if (error?.response?.url?.includes('/userprofile-service/userprofile/userProfileBase')) {
            AuthenticationUtil.toSSOSignin();
            return;
        }
    }

    return error;
}
